import { jsx as _jsx } from "react/jsx-runtime";
import Widget from 'app/components/Widget/Widget.jsx';
import MessagesTable from './MessagesTable';
const Messages = () => {
    return (_jsx(Widget, { style: { height: '100%', width: '100%' }, children: _jsx(MessagesTable, {}) }));
};
export default Messages;
